import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  isLoggedIn: boolean;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isLoggedIn,
  children,
}) => {
  const location = useLocation();

  if (!isLoggedIn) {
    if (!localStorage.getItem("postLoginRedirect")) {
      localStorage.setItem(
        "postLoginRedirect",
        location.pathname + location.search + location.hash
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
